export default __webpack_public_path__ + "static/media/msg-empty.c3dfb0d9.svg";